import React from 'react';

function Card(props) {
  const {children, className, cardId} = props;
  const newProps = {...props};
  delete newProps.children;
  delete newProps.className;
  delete newProps.cardId;

  return (
    <div
      id={cardId && `card-${cardId}`}
      {...newProps}
      className={`flex items-center justify-between h-14 p-2 px-4 rounded-md border border-inherit hover:border-bg-dark cursor-pointer ${className}`}
    >
      {children}
    </div>
  );
}

export default Card;
